import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function FloatingBackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on home page
  if (location.pathname === "/") {
    return null;
  }

  const handleBack = () => {
    // Blur any focused input first
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA")) {
      activeElement.blur();
      return;
    }

    // Navigate back
    navigate(-1);
  };

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={handleBack}
      aria-label="Go back"
      className={cn(
        "fixed bottom-6 left-6 z-50",
        "h-12 w-12 rounded-full",
        "bg-card/90 backdrop-blur-sm",
        "border border-border shadow-lg shadow-primary/10",
        "hover:bg-primary/10 hover:border-primary/50 hover:scale-110",
        "transition-all duration-300"
      )}
    >
      <ArrowLeft className="h-5 w-5 text-foreground" />
    </Button>
  );
}

export default FloatingBackButton;
